import Spinner from "@legacy/core/components/Spinner";
import { Component } from "react";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import Banner from "../../core/components/Banner";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import TextField from "../../core/fields/TextField";


class CreditNoteVoidForm extends Component {

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    renderButtons = () => {
        const {creditNote, voidData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, returnScroll} = this.props

        if (errors.unexpectedError) {
            return (
                <div className="data-panel__action-feedback">
                    <span className="text-invalid"><strong>An unexpected error occurred.</strong></span>
                </div>
            )
        }
        else {
            if (submitting) {
                return <Spinner centered={true} />
            }
            else {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="danger" text="Void" handler={event => requestAction("CREDIT_NOTE_VOID_SUBMIT")} />
                            <UniversalButton type="secondary" text="Cancel" handler={event => switchToPrimaryForm()} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
        }
    }

    render() {
        const {creditNote, voidData, requestAction, switchToPrimaryForm, submitting, errors, onFormDataChange, inventoryReturned, returnScroll} = this.props

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Credit Note Void">
                    <div className="data-panel__form" aria-label="Credit Note Void Form">
                        <p className="data-panel__form__caption">Please confirm that you'd like to void this credit note.</p>
                        <BasicDisplayField
                            fieldName="id"
                            fieldLabel="Roopairs Credit Note ID"
                            fieldValue={creditNote.custom_id ? creditNote.custom_id : creditNote.id}
                        ></BasicDisplayField>
                        <TextField
                            fieldName="void_message"
                            fieldLabel="Void Reason"
                            fieldValue={voidData.void_message || ""}
                            fieldOnChange={void_message => onFormDataChange("void_message", void_message || "")}
                            rows={3}
                            placeholder="Why are you voiding this credit note?"
                            errors={errors}
                        ></TextField>
                        {
                            inventoryReturned && (
                                <Banner type="warning" text="Parts on this credit note were returned to inventory. Voiding will reverse those inventory returns." />
                            )
                        }
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default CreditNoteVoidForm;
